export const UPLOAD_TYPES = {
	APPEND: 1,
	OVERRIDE: 2,
};
